/**
 * @fileoverview Analysis Panel
 * @description GPT-generated plain-language reading of a run's scores.
 */

import React from 'react';
import { Box, IconButton, Paper, Stack, Typography } from '@mui/material';
import { Sparkles, X } from 'lucide-react';

/**
 * Render the GPT interpretation panel.
 * @param {Object} props - Analysis payload and dismiss handler.
 * @returns {JSX.Element|null} Interpretation panel.
 */
export function AnalysisPanel({ analysis, onClose }) {
  if (!analysis) {
    return null;
  }

  const sections = [
    ['Strengths', analysis.strengths],
    ['Concerns', analysis.concerns],
    ['Recommended actions', analysis.recommendations],
  ];

  return (
    <Paper className="aier-analysis" elevation={0}>
      <Box className="aier-analysis-header">
        <Stack direction="row" spacing={1} alignItems="center">
          <Sparkles size={17} color="#0097A9" />
          <Typography className="aier-analysis-title">AI Insights</Typography>
        </Stack>
        <IconButton size="small" onClick={onClose} aria-label="Dismiss AI insights">
          <X size={16} />
        </IconButton>
      </Box>

      <Typography className="aier-analysis-summary">{analysis.executiveSummary}</Typography>

      <Box className="aier-analysis-grid">
        {sections.map(([title, items]) => (
          <Box key={title} className="aier-analysis-card">
            <Typography className="aier-analysis-card-title">{title}</Typography>
            <ul className="aier-analysis-list">
              {(items || []).map((item) => <li key={item}>{item}</li>)}
            </ul>
          </Box>
        ))}
      </Box>

      <Typography className="aier-analysis-footnote">{analysis.scoreInterpretation}</Typography>
    </Paper>
  );
}

export default AnalysisPanel;
